import iconYoga from "./images/iconYoga.png";
import iconFitness from "./images/iconFitness.png";
import iconMuscle from "./images/iconMuscle.png";
export const data = [
  {
    name: "Yoga",
    icon: iconYoga,
    description:
      "Enjoy yoga classes for all levels, body elastic, body weight workouts, etc",
  },
  {
    name: "Fitness",
    icon: iconFitness,
    description:
      "Regular strength training improves the health of your bone, muscles ",
  },
  {
    name: "Muscles",
    icon: iconMuscle,
    description: "Your trainer will prepare and show you to workout regime",
    last: true,
  },
];

export const packageDetails = [
  "2 times a week",
  "Personalized Exercise",
  "Personal Trainer",
];

export const trainingDetails = [
  "Strength Training",
  "Weightloss Training",
  "Cardio Training",
  "WeightGain Training",
  "Muscle Training",
];
